import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { type ModalContentProps } from '../../../state';
import { ModalLayout } from '../../layouts';
import styles from './styles';

type Props = ModalContentProps & {
  onUpload?: (file: File | null) => void;
};

const UploadLogoModal = ({ closeModal, onUpload }: Props) => {
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null);

  const handleFileSelect = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.onchange = (e) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0] || null;
      setSelectedFile(file);
    };
    fileInput.click();
  };

  const handleUpload = () => {
    if (onUpload) {
      onUpload(selectedFile);
    }
    closeModal();
  };

  const handleCancel = () => {
    setSelectedFile(null);
    closeModal();
  };

  return (
    <ModalLayout
      title=""
      closeModal={closeModal}
      onAccept={handleUpload}
      acceptText="Ανέβασμα"
      onCancel={handleCancel}
      cancelText="Ακύρωση"
    >
      <Stack spacing={3}>
        <Box sx={styles.uploadArea} onClick={handleFileSelect}>
          <CloudUpload sx={styles.uploadIcon} />

          <Typography variant="h6" color="text.secondary" sx={styles.title}>
            Σύρετε και αφήστε τα αρχεία εδώ
          </Typography>
        </Box>

        {selectedFile && (
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Επιλεγμένο αρχείο:
            </Typography>

            <Typography variant="body2" color="text.secondary">
              {selectedFile.name}
            </Typography>
          </Box>
        )}
      </Stack>
    </ModalLayout>
  );
};

export default UploadLogoModal;
